





















































































import BaseComponent from '@/components/base-component.vue';
import PrescriptionListTranscriptionSubTable from '@/components/prescription/list/transcription-sub-table.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import { errorHandling } from '@/helpers/errorHandling';
import {
  isDenied
} from '@/helpers/validatePrescriptionStatus';
import {
  isErrorOnSentToProduction, isTranscriptionApproved, isTranscriptionInProgress, isWaitingTranscription,
  isWaitingTranscriptionCompare
} from '@/helpers/validateTranscriptionStatus';
import IPrescription from '@/interfaces/prescription';
import { ITranscription } from '@/interfaces/transcription';
import PrescriptionModel from '@/models/prescription-model';
import TranscriptionModel from '@/models/transcription-model';
import * as service from '@/services/prescription';
import { getLocalUser } from '@/services/session-data';
import {
  ERROR_CODE_HAS_TRANSCRIPTION_IN_PROGRESS,
  ERROR_CODE_TRANSCRIPTION_IN_PROGRESS
} from '@/settings/consts/api-error';
import {
  MESSAGE_TRANSCRIPTION_IN_PROGRESS,
  MESSAGE_TRANSCRIPTION_ON_LOAD_ERROR
} from '@/settings/consts/messages';
import * as prescriptionStatus from '@/settings/consts/prescription-status';
import * as transcriptionStatus from '@/settings/consts/transcription-status';
import * as transcriptionTypes from '@/settings/consts/transcriptions-types';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';



@Component({
  components: {
    PermissionAuth,
    PrescriptionListTranscriptionSubTable,
    ListMessages,
  },
})
export default class PrescriptionListTranscriptionTable extends BaseComponent {
  @Prop()
  public data!: TranscriptionModel[];
  @Prop(Boolean)
  public hideCopy?: boolean;
  @Prop(Boolean)
  public hideProducts?: boolean;
  @Prop(Boolean)
  public hideStatus?: boolean;
  @Prop(Boolean)
  public hideClient?: boolean;
  @Prop({
    default: false,
  })
  public error: boolean;
  @Prop({
    default: false,
  })
  public loading: boolean;
  @Prop({
    default: 0,
  })
  public totalItems?: number;
  public pagination: any = {
    sortBy: 'id',
    totalItems: this.totalItems,
  };

  public headers: any[] = [];
  public currentUserId: string = null;

  get prescriptionStatus(): any {
    return prescriptionStatus;
  }

  @Watch('pagination')
  public onChangePagination(): void {
    this.$emit('changePagination', this.pagination);
  }

  public beforeMount(): void {
    this.setHeaders();
    getLocalUser().subscribe((currentUser) => {
      this.currentUserId = currentUser.idLogin;
    });
  }

  public getStatus(item: TranscriptionModel): any {
    let statusObject;

    if (item.emProgresso) {
      return {
        ...transcriptionStatus.TRANSCRIPTION_IN_PROGRESS,
        description: `Essa transcrição está sendo relizada por: ${item.transcritorAtual.nome}`,
      };
    }

    switch (item.status) {
      case transcriptionStatus.TRANSCRIPTION_APPROVED.key:
        statusObject = transcriptionStatus.TRANSCRIPTION_APPROVED;
        break;
      case transcriptionStatus.SCHEDULED_PRODUCTION.key:
        statusObject = transcriptionStatus.SCHEDULED_PRODUCTION;
        break;
      case transcriptionStatus.CANCELED_IN_PRODUCTION.key:
        statusObject = transcriptionStatus.CANCELED_IN_PRODUCTION;
        break;
      case transcriptionStatus.WAITING_TRANSCRIPTION.key:
        statusObject = transcriptionStatus.WAITING_TRANSCRIPTION;
        break;
      case transcriptionStatus.TRANSCRIPTION_IN_PROGRESS.key:
        statusObject = {
          ...transcriptionStatus.TRANSCRIPTION_IN_PROGRESS,
          description: `Essa transcrição está sendo relizada por: ${item.transcritorAtual.nome}`,
        };
        break;
      case transcriptionStatus.WAITING_TRANSCRIPTION_APPROVE.key:
        statusObject = transcriptionStatus.WAITING_TRANSCRIPTION_APPROVE;
        break;
      case transcriptionStatus.WAITING_TRANSCRIPTION_COMPARE.key:
        statusObject = transcriptionStatus.WAITING_TRANSCRIPTION_COMPARE;
        break;
      case transcriptionStatus.TRANSCRIPTION_DENIED.key:
        statusObject = transcriptionStatus.TRANSCRIPTION_DENIED;
        break;
      case transcriptionStatus.TRANSCRIPTION_ERROR_ON_SEND_TO_PRODUCTION.key:
        statusObject =
          transcriptionStatus.TRANSCRIPTION_ERROR_ON_SEND_TO_PRODUCTION;
        break;
      default:
        statusObject = {};
    }

    return statusObject;
  }

  public getPrescriptionStatus(item: IPrescription): any {
    let statusObject;

    switch (item.statusPrescricao) {
      case prescriptionStatus.WAITING_CLIENT.key:
        statusObject = prescriptionStatus.WAITING_CLIENT;
        break;
      case prescriptionStatus.WAITING_EMEDE.key:
        statusObject = prescriptionStatus.WAITING_EMEDE;
        break;
      case prescriptionStatus.SENT_TO_PRODUCTION.key:
        statusObject = prescriptionStatus.SENT_TO_PRODUCTION;
        break;
      case prescriptionStatus.WAITING_PHARMACEUTICAL_APPROVE.key:
        statusObject = prescriptionStatus.WAITING_PHARMACEUTICAL_APPROVE;
        break;
      case prescriptionStatus.DENIED.key:
        statusObject = prescriptionStatus.DENIED;
        break;
      case prescriptionStatus.ERROR_ON_SEND_TO_PRODUCTION.key:
        statusObject = prescriptionStatus.ERROR_ON_SEND_TO_PRODUCTION;
        break;
      default:
        statusObject = {};
    }

    return statusObject;
  }

  public isTranscriptionInProgress(item: ITranscription): boolean {
    return isTranscriptionInProgress(item.status) || item.emProgresso;
  }

  public isWaitingTranscriptionCompare(status): boolean {
    return isWaitingTranscriptionCompare(status);
  }

  public isWaitingTranscription(status): boolean {
    return isWaitingTranscription(status);
  }

  public isDenied(status): boolean {
    return isDenied(status);
  }

  public isTranscriptionApproved(status): boolean {
    return isTranscriptionApproved(status);
  }

  public isErrorOnSentToProduction(status): boolean {
    return isErrorOnSentToProduction(status);
  }

  public userCanUnlock(item: ITranscription): boolean {
    return (
      !!item.transcritorAtual && item.transcritorAtual.id === this.currentUserId
    );
  }

  public unlockTranscription(item: ITranscription): void {
    this.loader.start('Desbloqueando...');
    service.unsetTranscriptionProgress(item.id).subscribe(
      () => {
        this.loader.stop();
        this.$emit('reload');
      },
      () => {
        this.loader.stop();
      },
    );
  }

  public onViewItem(item: any, transcriptionId: string): void {
    this.loader.start('Carregando item...');
    service.getPrescriptionTranscription(item.idPrescricao).subscribe(
      (data) => {
        const prescription = new PrescriptionModel(data);
        prescription.idTranscricao = transcriptionId;
        this.loader.stop();
        this.$emit('view', prescription);
      },
      () => {
        this.loader.stop();
        this.toast.show('Ocorreu um erro ao carregar o item', 'error');
      },
    );
  }

  public onCancelItem(item: ITranscription): void {
    const updateItem = () => {
      this.loader.start('Recusando...');
      service.cancelTranscription(item.id).subscribe(() => {
        this.loader.stop();
        this.$emit('reload');
      }, error => {
        this.loader.stop();
        this.toast.show(error.data.message, 'error');
      });
    };

    this.dialog.show(
      'error',
      'Recusar Transcrição',
      'Tem certeza que deseja recusar essa transcrição?',
      'Cancelar',
      '',
      'Recusar',
      updateItem,
    );
  }

  public onTrascribeItem(item: any): void {
    this.loader.start('Carregando item...');

    const onError = (error) => {
      this.loader.stop();

      if (error.status === ERROR_CODE_HAS_TRANSCRIPTION_IN_PROGRESS) {
        const unsetTrascriptionProgress = () => {
          service
            .unsetTranscriptionProgress(error.data.message)
            .subscribe(() => {
              this.onTrascribeItem(item);
            });
        };

        this.dialog.show(
          'warn',
          'Transcrição em progresso',
          'Você já possui um transcrição em progresso, para iniciar uma nova é preciso liberar a anterior.',
          'Cancelar',
          '',
          'Liberar',
          () => unsetTrascriptionProgress(),
        );
      } else {
        const errorMessages = {
          default: MESSAGE_TRANSCRIPTION_ON_LOAD_ERROR,
          [ERROR_CODE_TRANSCRIPTION_IN_PROGRESS]: MESSAGE_TRANSCRIPTION_IN_PROGRESS,
        };

        const message = errorHandling(error, errorMessages);

        this.toast.show(message, 'error');
      }
    };

    service.getTranscription(item.id).subscribe((data) => {
      service.setTranscriptionProgress(item.id).subscribe(() => {
        const payload = new PrescriptionModel();
        payload.idTranscricao = data.id;
        payload.transcricao = data;
        payload.unidade = data.unidade;
        payload.paciente = data.paciente;
        payload.nomeArquivoTranscricao = data.nomeArquivo;
        payload.pathArquivoTranscricao = data.pathArquivo;
        if (item.prescricoes.length) {
          payload.tipoTranscricao = transcriptionTypes.TRANSCRIPTION_CHECK;
        } else {
          payload.tipoTranscricao = transcriptionTypes.TRANSCRIPTION;
        }
        
        this.$emit('edit', payload);
        this.loader.stop();
      });
    }, onError);
  }

  public onCompareItem(item: any): void {
    this.loader.start('Carregando item...');

    const onError = (error) => {
      this.loader.stop();

      const errorMessages = {
        default: MESSAGE_TRANSCRIPTION_ON_LOAD_ERROR,
      };

      const message = errorHandling(error, errorMessages);

      this.toast.show(message, 'error');
    };

    service.getTranscription(item.id).subscribe((data) => {
      const prescriptions = data.prescricoes.map(
        (prescription) => new PrescriptionModel(prescription),
      );
      this.$emit('compare', item, prescriptions);
      this.loader.stop();
    }, onError);
  }

  private setHeaders(): void {
    this.headers.push({ text: 'ID', value: 'id', class: 'px-2' });
    this.headers.push({
      text: 'Iniciado Por',
      value: 'iniciadoPor',
      class: 'px-2',
    });

    this.headers.push({
      text: 'Produção em',
      value: 'p.dataProducao',
      class: 'px-2',
    });
    
    this.headers.push({
      text: 'Entrega em',
      value: 'p.dataPrescricao',
      class: 'px-2',
    });

    this.headers.push({
      text: 'Criado em',
      value: 'dataInclusao',
      class: 'px-2',
    });

    if (!this.hideClient) {
      this.headers.push({
        text: 'Unidade',
        value: 'unidade.nome',
        class: 'px-2',
      });
    }

    this.headers.push({
      text: 'Médico',
      value: 'medico.nome',
      class: 'px-2',
    });
    this.headers.push({
      text: 'Paciente',
      value: 'paciente.nome',
      class: 'px-2',
    });
    this.headers.push({
      text: 'Transcrições coincidentes',
      value: 'p.contador',
      align: 'center',
      sortable: false,
      class: 'px-2',
    });

    if (!this.hideStatus) {
      this.headers.push({
        text: 'Status',
        value: 'status',
        align: 'center',
        class: 'px-2',
      });
    }

    this.headers.push({
      text: 'Ações',
      value: 'actions',
      align: 'center',
      sortable: false,
      class: 'px-2',
    });
  }
}
